import Head from './pages/header'
import Bottom from './pages/bottom'
import Home from './pages/home'
import Map from './pages/map'
import Divider from './pages/divider'
import Center from './pages/center'
import "./index.css"

function App() {
  return (
    <>
    <Head></Head>
    <Home></Home>
    <Center></Center>
    <Divider></Divider>
    <Map></Map>
    <Bottom></Bottom>
    </>
  );
}

export default App;
